import { render } from "./NewsDetailsView.vue?vue&type=template&id=6b977b06&scoped=true"
import script from "./NewsDetailsView.vue?vue&type=script&lang=js"
export * from "./NewsDetailsView.vue?vue&type=script&lang=js"

import "./NewsDetailsView.vue?vue&type=style&index=0&id=6b977b06&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b977b06"]])

export default __exports__